import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getTransferOutbyId } from "Config/API/get";
import useFullPageLoader from "Hooks/useFullPageLoader";
import { toast } from "react-toastify";
import { modifyTransferOutRequest } from "Config/API/action";
import { useNavigate } from "react-router-dom";
import AcceptTransferOutRequest from "Components/Popup/AcceptTransferOutRequest/AcceptTransferOutRequest";

const TransferOutForm = () => {
    const token = localStorage.getItem("token");
    const id = useSelector((state) => state.raisetransferRequestIdReducer);
    const loggedInUser = useSelector((state) => state.authenticationReducer);
    const navigate = useNavigate();
    const [loader, setLoader, resetLoader] = useFullPageLoader();
    const [showAcceptRequestPopup, setShowAcceptRequestPopup] = useState(false);

    // ✅ ALWAYS initialize with empty values
    const [transferoutData, setTransferoutData] = useState({
        organization_name: "",
        userName: "",
        email: "",
        credit: "",
        accountNumber: "",
        routingNumber: "",
        comment: "",
        status:"",
    });

    useEffect(() => {
        const fetchTransferOut = async () => {
            setLoader();
            try {
                const res = await getTransferOutbyId(token, id);
                if (res?.status && res?.data) {
                    setTransferoutData({
                        organization_name: res.data.organization_name || "",
                        userName: res.data.userName || "",
                        email: res.data.email || "",
                        credit: res.data.credit || "",
                        accountNumber: res.data.accountNumber || "",
                        routingNumber: res.data.routingNumber || "",
                        comment: res.data.comment || "",
                        status: res.data.status || "",
                    });
                } else {
                    toast(res?.message || "Failed to load transfer details", {
                        type: "error",
                    });
                }
            } catch (error) {
                toast("Failed! Try again later", { type: "error" });
            } finally {
                resetLoader();
            }
        };

        fetchTransferOut();
    }, []);

    const isManager =
        loggedInUser?.ticket_external_role === "manager" ||
        loggedInUser?.ticket_internal_role === "manager";
    const [loading, setLoading] = useState(false);
    const changeStatus = async (action, trn) => {
        if (loading) return;

        setLoading(true);

        try {
            let statusValue = "";

            if (action === "approve") {
                statusValue = "approved";
            } else if (action === "reject") {
                statusValue = "rejected";
            }

            const res = await modifyTransferOutRequest(
                token,
                id,
                statusValue,
                action === "approve" ? trn : ""
            );

            if (res?.status) {
                toast(res?.message || "Status updated successfully", {
                    type: "success",
                });
                navigate("/all-transfer-out-requests")
            } else {
                toast(res?.message || "Failed to update status", {
                    type: "error",
                });
            }
        } catch (error) {
            toast("Something went wrong. Please try again.", {
                type: "error",
            });
        } finally {
            setLoading(false);
        }
    };
console.log({transferoutData});
    return (
        <>
           <div className="straisereqshow-parent" style={{ overflow: 'visible', height: 'auto', minHeight: '100vh' }}>
  <div className='straisereqshow-main' style={{ overflow: 'visible', height: 'auto' }}>
    <div className='straisereqshow-form-body' style={{ overflow: 'visible', height: 'auto' }}>
        
                    <form className="straisereqshow-form-body" autoComplete="off">
                <div
  style={{
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    borderBottom: "1px solid #e5e5e5",
    padding: "12px 0"
  }}
>
  {/* Back Button */}
  <button
    type="button"
    onClick={() => navigate("/all-transfer-out-requests")}
    style={{
      position: "absolute",
      left: "0",
      top: "50%",
      transform: "translateY(-50%)",
      background: "transparent",
      border: "none",
      color: "#007bff",
      cursor: "pointer",
      fontSize: "15px",
      display: "flex",
      alignItems: "center",
      padding: "0 10px",
      height: "100%"
    }}
  >
    <span style={{ fontSize: "18px", marginRight: "4px" }}>←</span>
    Back
  </button>

  {/* Page Title */}
  <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 600 }}>
    Transfer Out Request
  </h2>
                        </div>


                        

                        <div className="straisereqshow-wrapper">
                            {/* Requestor Organization */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Requestor Organization<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.organization_name}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Requestor Name */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Requestor Name<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.userName}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Requestor Email */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Requestor Email<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.email}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Credit */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Balance<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.credit}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Account Number */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Account Number<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.accountNumber}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Routing Number */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Routing Number<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.routingNumber}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Comment */}
                            <div className="straisereqshow-fields">
                                <label>
                                    Comment<span>*</span>:
                                </label>
                                <input
                                    type="text"
                                    value={transferoutData.comment}
                                    readOnly
                                    style={{ backgroundColor: "#f1f2f6" }}
                                />
                            </div>

                            {/* Approve Button */}
                            {transferoutData?.status?.toString() === "pending" ? (

                            <div style={{ display: "flex", justifyContent: "center", gap: "12px" }}>
                                <button
                                    type="button"
                                    className="straisereqshow-button"
                                    disabled={!isManager || loading}
                                    style={{
                                        backgroundColor: !isManager ? "grey" : "",
                                        cursor: !isManager || loading ? "not-allowed" : "pointer",
                                    }}
                                    onClick={() => setShowAcceptRequestPopup(true)}
                                >
                                    {loading ? "Processing..." : "Approve"}
                                </button>

                                    <button
                                        type="button"
                                        className="straisereqshow-button"
                                        disabled={!isManager || loading}
                                        style={{
                                            backgroundColor: !isManager ? "grey" : "rgb(203, 18, 18)",
                                            cursor: !isManager || loading ? "not-allowed" : "pointer",
                                        }}
                                        onClick={() => changeStatus("reject", "")}
                                    >
                                        {loading ? "Processing..." : "Reject"}
                                    </button>
                                </div>

                            ) : (
                                <div style={{ display: "flex", justifyContent: "center", gap: "12px", color: transferoutData?.status === "approved" ? "rgb(92, 161, 39)" : "rgb(203, 18, 18)", fontWeight: "bold" }} >Transfer out request is {transferoutData?.status}</div>
                            )}

                        </div>
                    </form>
                </div>
            </div>
            </div>
            {showAcceptRequestPopup && (
                <AcceptTransferOutRequest
                    hide={setShowAcceptRequestPopup}
                    changeStatus={changeStatus}
                />
            )}
            {loader}
        </>
    );
};

export default TransferOutForm;
